import React from 'react';
import { ComponentOverridesConsumer } from '@bubble-ui/provider-component-overrides';
// Extracted directly from https://github.com/acdlite/recompose/blob/master/src/packages/recompose/getDisplayName.js
// The motivation is to stop having recompose around as a dependency
var getDisplayName = Component => {
  return Component.displayName || Component.name || 'Component';
};
export function withProvisionalOverrideFromContext(Target) {
  var name = getDisplayName(Target);
  class WithPropsFromContext extends React.PureComponent {
    render() {
      return /*#__PURE__*/React.createElement(ComponentOverridesConsumer, null, value => {
        if (Object.keys(value).includes(name)) {
          var override = value[name];
          if (typeof override === 'function') {
            var Override = override;
            return /*#__PURE__*/React.createElement(Override, this.props);
          }
        }
        return /*#__PURE__*/React.createElement(Target, this.props);
      });
    }
  }

  // @ts-expect-error
  WithPropsFromContext.displayName = name;
  return WithPropsFromContext;
}
//# sourceMappingURL=index.js.map